var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('HeaderTop'),_c('MenuPage'),_c('BannerDetail',{attrs:{"backgroundImage":require('../assets/img/banner2.jpg'),"title":_vm.$t('productssub3'),"description":_vm.$t('software2')}}),_c('div',{staticClass:"product-main"},[_c('SoftItem')],1),_c('div',{staticClass:"footer-main"},[_vm._v(" "+_vm._s(_vm.$t("footertitile"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }